import { initialState } from './reducers'

export const select = (state) => state || initialState

export const selectUser = (state) => select(state).auth
